// The Gatsby build needs this import.
// eslint-disable-next-line no-redeclare
import { CardMedia, styled } from '@mui/material';
import { MuiImageProps } from './MuiImage';

export const MuiImageBackground = styled((props: MuiImageProps) => (
  <CardMedia component="div" role="img" {...props} />
))(({ theme, src }) => ({
  border: 0,
  backgroundImage: 'url("' + src + '")'
}));